/* 项目统一配置文件   测试环境*/

const xmGlobal = {
  // 本地环境
  baseUrl: "https://pre.xiaoma.com.tw/api/dxz/",
  timeout: 10000, //单位毫秒
};
export default xmGlobal;


